import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import Progress from '../Progress';
import { uploadClass } from './styles';
import Image from '../Image';
import { ERROR } from './request';

var ImageFile =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ImageFile, _PureComponent);

  var _super = _createSuper2(ImageFile);

  function ImageFile(props) {
    var _this;

    _classCallCheck(this, ImageFile);

    _this = _super.call(this, props);
    _this.handleRemove = _this.handleRemove.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ImageFile, [{
    key: "handleRemove",
    value: function handleRemove() {
      this.props.onRemove(this.props.id);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          process = _this$props.process,
          status = _this$props.status,
          style = _this$props.style,
          data = _this$props.data,
          message = _this$props.message;
      var className = uploadClass('image-item', status === ERROR && 'error');
      return (
        /*#__PURE__*/
        React.createElement("div", {
          style: style,
          className: className
        }, data &&
        /*#__PURE__*/
        React.createElement(Image, {
          src: data,
          fit: "center",
          width: "auto",
          height: 0,
          className: uploadClass('image-bg')
        }), message &&
        /*#__PURE__*/
        React.createElement("div", {
          className: uploadClass('message')
        }, message),
        /*#__PURE__*/
        React.createElement("span", {
          className: uploadClass('delete'),
          onClick: this.handleRemove
        }),
        /*#__PURE__*/
        React.createElement("div", {
          className: uploadClass('progress-bg')
        },
        /*#__PURE__*/
        React.createElement(Progress, {
          className: uploadClass('progress'),
          color: "#f2f2f2",
          background: "rgba(0,0,0,0.5)",
          value: process,
          strokeWidth: 2
        })))
      );
    }
  }]);

  return ImageFile;
}(PureComponent);

export default ImageFile;